import { Next } from '@securitize/ui-components';

export const getNotificationsNext = new Next('/notifications', 'GET_NOTIFICATIONS');

export const removeNotificationNext = new Next('/notifications/{id}', 'REMOVE_NOTIFICATION', { method: 'delete' });

export const markNotificationReadNext = new Next('/notifications/mark-read', 'MARK_NOTIFICATION', { method: 'post' });
